import { makeEntity } from 'react-entities'
import * as user from './user'
import * as account from './account'
import * as message from './message'

export const useUser = makeEntity(user)
export const useAccount = makeEntity(account)
export const useMessage = makeEntity(message)
